// extracted by mini-css-extract-plugin
export var copyableField = "_rv-4";
export var customerBadge = "_rv-0";
export var customerInfoTitle = "_rv-2";
export var details = "_rv-1";
export var dropdownContainer = "_rv-5";
export var dropdownImage = "_rv-6";
export var editAssigneeForm = "_rv-a";
export var editButton = "_rv-3";
export var email = "_rv-7";
export var hidden = "_rv-d";
export var input = "_rv-8";
export var saveButton = "_rv-b";
export var shopifyIcon = "_rv-c";
export var suggestionBadge = "_rv-e";
export var suggestionText = "_rv-f";
export var username = "_rv-9";